var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecoveryPlanIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 13.5,
    fill: "#E7E0F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 7,
    r: 7,
    fill: "#E7E0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 29.3333C6.43333 29.3333 5.80556 29.0722 5.28333 28.55C4.76111 28.0278 4.5 27.4 4.5 26.6667V7.99999C4.5 7.26666 4.76111 6.63888 5.28333 6.11666C5.80556 5.59443 6.43333 5.33332 7.16667 5.33332H8.5V2.66666H11.1667V5.33332H21.8333V2.66666H24.5V5.33332H25.8333C26.5667 5.33332 27.1944 5.59443 27.7167 6.11666C28.2389 6.63888 28.5 7.26666 28.5 7.99999V26.6667C28.5 27.4 28.2389 28.0278 27.7167 28.55C27.1944 29.0722 26.5667 29.3333 25.8333 29.3333H7.16667ZM7.16667 26.6667H25.8333V13.3333H7.16667V26.6667ZM7.16667 10.6667H25.8333V7.99999H7.16667V10.6667ZM9.83333 18.6667V16H23.1667V18.6667H9.83333ZM9.83333 24V21.3333H19.1667V24H9.83333Z",
    fill: "#873CAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoveryPlanIcon);
export default __webpack_public_path__ + "static/media/recovery_plan_icon.1258f6d8ec1274d7aeb8055140ca7ef3.svg";
export { ForwardRef as ReactComponent };